import {
  getCitation,
  getFormatted,
  mergeItems
} from "../../lib/formatUtilities.js";

export default {
  Title: "University of Colorado",
  template: "/templateFiles/colorado_template_v1_0.docx",
  outputSettings: { font: "Arial", fontSize: 10.5 },
  output: {
    bio: {
      field: "bio",
      map: {
        bio_name: "name",
        bio_title: "title",
        bio_workEmail: "workEmail",
        bio_officeAddress: "officeAddress"
      }
    },
    // Education
    edu: {
      field: "education",
      group: {
        eduU: {
          filter: (n) => n.type === "undergraduate",
          format: {
            t: ["limitedMonthAndFullYear"],
            1: [mergeItems([{ key: "location" }, { key: "degree" }])]
          }
        },
        eduG: {
          filter: (n) => n.type === "graduate",
          format: {
            t: ["limitedMonthAndFullYear"],
            1: [mergeItems([{ key: "location" }, { key: "degree" }])]
          }
        }
      }
    },
    res: {
      field: "postDoctoralTraining",
      group: {
        resI: {
          filter: (n) => n.type === "internship",
          format: {
            t: ["limitedMonthAndFullYear"],
            1: [mergeItems([{ key: "location" }, { key: "title" }])]
          }
        },
        resR: {
          filter: (n) => n.type === "residency",
          format: {
            t: ["limitedMonthAndFullYear"],
            1: [mergeItems([{ key: "location" }, { key: "title" }])]
          }
        },
        resF: {
          filter: (n) => n.type === "fellowship",
          format: {
            t: ["limitedMonthAndFullYear"],
            1: [mergeItems([{ key: "location" }, { key: "title" }])]
          }
        },
        resP: {
          filter: (n) => n.type === "postdoc",
          format: {
            t: ["limitedMonthAndFullYear"],
            1: [mergeItems([{ key: "location" }, { key: "title" }])]
          }
        }
      }
    },
    aa: {
      field: "facultyAppointments",
      format: {
        t: ["limitedMonthAndFullYear"],
        1: [
          mergeItems([{ key: "title" }, { key: "field" }, { key: "location" }])
        ]
      }
    },
    ha: {
      field: "hospitalAppointments",
      format: {
        t: ["limitedMonthAndFullYear"],
        1: [
          mergeItems([{ key: "title" }, { key: "field" }, { key: "location" }])
        ]
      }
    },
    ms: {
      field: "military",
      format: {
        t: ["limitedMonthAndFullYear"],
        1: [mergeItems([{ key: "title" }, { key: "description" }])]
      }
    },
    op: {
      field: "otherPositions",
      format: {
        t: ["limitedMonthAndFullYear"],
        1: [
          mergeItems([{ key: "title" }, { key: "field" }, { key: "location" }])
        ]
      }
    },
    hon: {
      field: "honors",
      format: {
        t: ["limitedMonthAndFullYear"],
        1: [
          mergeItems([
            { key: "title" },
            { key: "location" },
            { key: "description" }
          ])
        ]
      }
    },
    org: {
      field: "societies",
      format: {
        t: ["limitedMonthAndFullYear"],
        1: ["society"]
      },
      sublist: {
        roles: {
          t: ["limitedMonthAndFullYear"],
          1: [getFormatted("roles", { indent: 600 })]
        }
      }
    },
    com: {
      field: "committeeService",
      group: {
        comDept: {
          filter: (n) => n.type === "dept",
          format: {
            t: ["limitedMonthAndFullYear"],
            1: [mergeItems([{ key: "title" }, { key: "location" }])]
          },
          sublist: {
            roles: {
              t: ["limitedMonthAndFullYear"],
              1: [getFormatted("roles", { indent: 600 })]
            }
          }
        },
        comSOM: {
          filter: (n) => n.type === "school",
          format: {
            t: ["limitedMonthAndFullYear"],
            1: [mergeItems([{ key: "title" }, { key: "location" }])]
          },
          sublist: {
            roles: {
              t: ["limitedMonthAndFullYear"],
              1: [getFormatted("roles", { indent: 600 })]
            }
          }
        },
        comUni: {
          filter: (n) => n.type === "institutional",
          format: {
            t: ["limitedMonthAndFullYear"],
            1: [mergeItems([{ key: "title" }, { key: "location" }])]
          },
          sublist: {
            roles: {
              t: ["limitedMonthAndFullYear"],
              1: [getFormatted("roles", { indent: 600 })]
            }
          }
        },
        comH: {
          filter: (n) => n.type === "local",
          format: {
            t: ["limitedMonthAndFullYear"],
            1: [mergeItems([{ key: "title" }, { key: "location" }])]
          },
          sublist: {
            roles: {
              t: ["limitedMonthAndFullYear"],
              1: [getFormatted("roles", { indent: 600 })]
            }
          }
        }
      }
    },
    // Licensure
    lic: {
      field: "clinicalActivityAndInnovations",
      format: {
        t: ["limitedMonthAndFullYear"],
        1: [mergeItems([{ key: "title" }, { key: "description" }])]
      }
    },
    inv: {
      field: "technologyAndScienceInnovations",
      format: {
        t: ["limitedMonthAndFullYear"],
        1: [mergeItems([{ key: "title" }, { key: "description" }])],
        2: ["role"]
      }
    },
    rev: {
      field: "grantReviewActivities",
      format: {
        t: ["limitedMonthAndFullYear"],
        1: [mergeItems([{ key: "committee" }, { key: "location" }])]
      },
      sublist: {
        roles: {
          t: ["limitedMonthAndFullYear"],
          1: [getFormatted("roles", { indent: 600 })]
        }
      }
    },
    pres: {
      field: "presentations",
      group: {
        presLoc: {
          filter: (n) => n.type === "local",
          format: {
            t: ["limitedMonthAndFullYear"],
            1: [mergeItems([{ key: "title" }, { key: "organization" }])]
          }
        },
        presReg: {
          filter: (n) => n.type === "regional",
          format: {
            t: ["limitedMonthAndFullYear"],
            1: [mergeItems([{ key: "title" }, { key: "organization" }])]
          }
        },
        presNat: {
          filter: (n) => n.type === "national",
          format: {
            t: ["limitedMonthAndFullYear"],
            1: [mergeItems([{ key: "title" }, { key: "organization" }])]
          }
        },
        presInt: {
          filter: (n) => n.type === "international",
          format: {
            t: ["limitedMonthAndFullYear"],
            1: [mergeItems([{ key: "title" }, { key: "organization" }])]
          }
        }
      }
    },
    // teach
    teach: {
      field: "teaching",
      group: {
        teachU: {
          filter: (n) => n.audience === "Undergraduate",
          format: {
            t: ["limitedMonthAndFullYear"],
            1: [mergeItems([{ key: "title" }, { key: "courseNumber" }])],
            2: [mergeItems([{ key: "role" }, { key: "description" }])]
          }
        },
        teachG: {
          filter: (n) => n.audience === "Graduate",
          format: {
            t: ["limitedMonthAndFullYear"],
            1: [mergeItems([{ key: "title" }, { key: "courseNumber" }])],
            2: [mergeItems([{ key: "role" }, { key: "description" }])]
          }
        },
        teachH: {
          filter: (n) => n.audience === "House Officers",
          format: {
            t: ["limitedMonthAndFullYear"],
            1: [mergeItems([{ key: "title" }, { key: "courseNumber" }])],
            2: [mergeItems([{ key: "role" }, { key: "description" }])]
          }
        },
        teachO: {
          filter: (n) =>
            !["Undergraduate", "Graduate", "House Officers"].includes(
              n.audience
            ),
          format: {
            t: ["limitedMonthAndFullYear"],
            1: [mergeItems([{ key: "title" }, { key: "courseNumber" }])],
            2: [mergeItems([{ key: "role" }, { key: "description" }])]
          }
        }
      }
    },
    gra: {
      field: "projects",
      group: {
        graF: {
          filter: (n) => n.type === "funded",
          format: {
            t: ["limitedMonthAndFullYear"],
            1: [
              mergeItems([
                { key: "title" },
                { key: "fundingSource" },
                { key: "grantTypeAndNumber" }
              ])
            ],
            2: [
              mergeItems([
                { key: "role" },
                { key: "workTime" },
                { key: "directCosts" }
              ])
            ]
          }
        },
        graS: {
          filter: (n) => n.type === "submitted",
          format: {
            t: ["limitedMonthAndFullYear"],
            1: [
              mergeItems([
                { key: "title" },
                { key: "fundingSource" },
                { key: "grantTypeAndNumber" }
              ])
            ],
            2: [
              mergeItems([
                { key: "role" },
                { key: "workTime" },
                { key: "directCosts" }
              ])
            ]
          }
        },
        graU: {
          filter: (n) => n.type === "unfunded",
          format: {
            t: ["limitedMonthAndFullYear"],
            1: [
              mergeItems([
                { key: "title" },
                { key: "fundingSource" },
                { key: "grantTypeAndNumber" }
              ])
            ],
            2: [
              mergeItems([
                { key: "role" },
                { key: "workTime" },
                { key: "directCosts" }
              ])
            ]
          }
        }
      }
    },
    // bibliography
    bib: {
      field: "scholarship",
      format: {
        t: ["limitedMonthAndFullYear"],
        1: function (item, i, cvDef, genOpts) {
          return [
            getCitation("line")(item, i, cvDef, genOpts),
            getFormatted("comments", { indent: 600 })(item, i, cvDef, genOpts)
          ].join(genOpts.noXML ? "<br>" : "");
        },
        2: function (item, i, cvDef, genOpts) {
          return getFormatted("PMID")(item, i, cvDef, genOpts);
        }
      },
      sections: [
        {
          title: "Peer-Reviewed Articles",
          type: "Research Investigations"
        },
        {
          title: "Books and Monographs",
          type: "books"
        },
        {
          title: "Book Chapters",
          type: "chapters"
        },
        {
          title: "Invited Articles & Reviews in non Peer-Reviewed Journals",
          type: "Proceedings of meetings or other non-peer reviewed scholarship"
        },
        {
          title: "Other Peer-Reviewed Publications",
          type: "otherPeer"
        },
        {
          title: "Reports",
          type: "Clinical Guidelines and Reports"
        },
        {
          title: "Policy",
          type: "policy"
        },
        {
          title: "Products of Scholarship",
          type: "nonprint"
        },
        {
          title: "Letters to the Editor",
          type: "Letters to the Editor"
        },
        {
          title: "Abstracts",
          type: "Abstracts, Poster Presentations and Exhibits Presented at Professional Meetings"
        }
      ]
    }
  }
};
